<template>
	<el-dialog 
		:lang="$i18n.locale" 
		:title="$t('commonInfo.trackingTitle')" 
		:visible.sync="visible" 
		width="1100px" 
		append-to-body 
		:close-on-click-modal="false"
		class="timeline" 
		:before-close="handleDialogClose"
	>
		<div style="text-align:right;font-size:18px;color:red">
			<span>{{onRemarks}}</span>
			<span v-show="isShow">：</span>
			<span>{{warehouseTime}}</span>
		</div>
		<div class="dialog_orderNo">
			<label>{{rowOrderNo}}</label>
		</div>
		<el-timeline>
			<el-timeline-item 
				v-for="(activity, index) in activities" 
				:key="index" 
				color="green"
				:timestamp="(activity.initTime +' '+'Time Zone：Beijing')" 
				placement="top"
			>
				<el-card>
					<!-- 轨迹区域 -->
					<h4>{{activity.description}}</h4>
					<!-- location -->
					<p v-show="activity.location==false?false:activity.location==null?false:true">
						{{$t('commonInfo.trackLocation') + ':'}}
						<span style="font-weight:700">{{activity.location}}</span>
					</p>
					<!-- 备注 -->
					<p>
						{{$t('commonInfo.remark') + ':'}}
						<span style="font-weight:700">{{activity.remarks}}</span>
					</p>
				</el-card>
			</el-timeline-item>
		</el-timeline>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleDialogClose">{{$t('commonInfo.dialogBtnConfirm')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'CheckTracking',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		orderNo: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			rowOrderNo: '',
			activities: [],
			warehouseTime: "",
			onRemarks: "",
			isShow: false
		};
	},
	watch: {
		visible(val) {
			if (val && this.orderNo) {
				this.loadTrackingData();
			}
		},
		orderNo() {
			if (this.visible) {
				this.loadTrackingData();
			}
		}
	},
	methods: {
		handleDialogClose() {
			this.$emit('update:visible', false);
		},
		async loadTrackingData() {
			if (!this.orderNo) return;
			
			const res = await this.$http.get(
				"/toborder/trackinfo/" + this.orderNo
			);
			this.rowOrderNo = this.orderNo;
			if (res.code === 200) {
				this.activities = res.data.mainOrderTrackingList;
				if (this.activities.length === 0) {
					this.$emit('update:visible', false);
					//输入的订单号不存在
					this.$message.error(this.$t('tipsInfo.orderNoExistTips'));
				}
				this.activities.forEach(item => {
					if (item.status == 1000 && item.id) {
						this.warehouseTime = item.description;
						this.onRemarks = item.remarks;
						this.isShow = true;
					}
				});
			} else {
				this.$message.error(res.msg);
			}
		}
	}
};
</script>

<style scoped>
.dialog_orderNo{
	width: 100%;
	height: 50px;
	line-height: 40px;
}
.dialog_orderNo label{
	margin-left: 40px;
	font-weight: bold;
	border-radius: 8px;
	font-size: 20px;
	padding: 5px 15px;
	border: 1px solid #EBEEF5;
	box-shadow: 0 2px 4px 0 rgb(0 0 0 / 30%);
}

.dialog-footer {
	text-align: center;
}

/* 阿拉伯语样式 */
[lang="ar"] {
	.dialog_orderNo label {
		margin-left: 0;
		margin-right: 40px;
	}
	
	.dialog-footer {
		text-align: left;
	}
}
</style>